export default "__VITE_ASSET__bc5d7a90__"